import React from "react";
import { Button, Icon } from "react-materialize";
import MenuItem from "components/infos/MenuItem";
import { useHistory } from "react-router-dom";
import config from "./../../config";
import { useInfo } from "context/InfoContext";

export default function MenuLeft({ id, userData, staffID, tabActive }) {
  const history = useHistory();
  const { infos } = useInfo();
  staffID = parseInt(staffID);
  const isCannotEdit =
    userData?.user_sess?.userCanAccessHrAssign ||
    userData?.user_sess?.isAdmin ||
    userData?.user_sess?.isITManager ||
    userData?.user_sess?.isInfoSysManager
      ? false
      : true;
  const isITorInfoSys =
    (userData?.user_sess?.isITManager ||
      userData?.user_sess?.isInfoSysManager) &&
    !userData?.user_sess?.userCanAccessHrAssign &&
    !userData?.user_sess?.isAdmin
      ? true
      : false;
  const isEnablePersonalTab =
    staffID > 0 || (staffID === 0 && infos.isNext === 1) ? true : false;
  // const isMyProfile = id === "myprofile-leftcontent" ? true : false;
  const handleEvents = {
    MenuItem: {
      OnClick: function (data) {
        if (data?.disable) return;
        let path = "";
        if (data.id === "myprofile") {
          path = "/employees/myprofile";
        } else {
          if (data.id === "adminconsole") {
            data.id = "usergroups";
          }
          path = "/employees/profile?tab=" + data.id;
          if (staffID > 0) {
            path += "&id=" + staffID;
          }
        }
        history.push(path);
      },
    },
  };
  return (
    <ul
      id={id}
      className="col s2 collection"
      style={{
        padding: "0",
        marginTop: "0px",
        border: "none",
      }}
    >
      {!isITorInfoSys ? (
        <MenuItem
          data={{
            id: "employeeinfo",
            text: "Employee Infomation",
            tabActive: tabActive,
            disable: false,
          }}
          handleEvents={handleEvents.MenuItem}
        />
      ) : (
        ""
      )}
      {!isITorInfoSys ? (
        <MenuItem
          data={{
            id: "personaldata",
            text: "Personal Data",
            tabActive: tabActive,
            disable: isEnablePersonalTab ? false : true,
            // disable: false,
          }}
          handleEvents={handleEvents.MenuItem}
        />
      ) : (
        ""
      )}
      {!isCannotEdit ? (
        <MenuItem
          data={{
            id: "notification",
            text: "Notification",
            tabActive: tabActive,
            disable: staffID > 0 ? false : true,
          }}
          handleEvents={handleEvents.MenuItem}
        />
      ) : (
        ""
      )}
      {userData?.user_sess?.isAdmin ? (
        <MenuItem
          data={{
            id: "adminconsole",
            text: "Admin Console",
            tabActive: tabActive,
            disable: staffID > 0 ? false : true,
          }}
          handleEvents={handleEvents.MenuItem}
        />
      ) : (
        ""
      )}
      {userData?.user_sess?.isAdmin ? (
        <div
          id="adminconsole-menu-list"
          className={"collection-item row" + (staffID > 0 ? "" : " disable")}
        >
          <MenuItem
            data={{
              id: "usergroups",
              text: "User Groups",
              tabActive: tabActive,
              disable: staffID > 0 ? false : true,
            }}
            handleEvents={handleEvents.MenuItem}
          />
          <MenuItem
            data={{
              id: "dashboardaccess",
              text: "Dashboard Access",
              tabActive: tabActive,
              disable: staffID > 0 ? false : true,
            }}
            handleEvents={handleEvents.MenuItem}
          />
        </div>
      ) : (
        ""
      )}
      <li style={{ marginTop: "15px" }}>
        <Button flat node="a" waves="light" href={`/${config.mainDir}`}>
          BACK
          <Icon left>arrow_back</Icon>
        </Button>
      </li>
    </ul>
  );
}
